/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDashBorderAll = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M7 13v-2h2v2zm4-4V7h2v2zm0 4v-2h2v2zm0 4v-2h2v2zm4-4v-2h2v2z" />
        <path d="M2 22V2h20v20zM13 4v1h-2V4H4v7h1v2H4v7h7v-1h2v1h7v-7h-1v-2h1V4z" />
      </g>
    </g>
  </Icon>
);
export { SvgDashBorderAll as DashBorderAll };
